import { ProgressBar } from 'react-loader-spinner';
import "./spinner.scss";

const Spinner = () => {
  return (
    <div className='spinner'>
      <ProgressBar
        height="80"
        width="80"
        ariaLabel="progress-bar-loading"
        wrapperStyle={{}}
        wrapperClass="progress-bar-wrapper"
        borderColor = '#000'
        barColor = '#bf9e1d'
      />
    </div>
  );
}

export default Spinner;